@import '../../styles/palette.scss';
@import '../../styles/constants.scss';

$padding: 14px;
$icon-width: 20px;

.inputWrapper {
  border: solid 1px _palette(input-border-primary);
  height: 52px;
  line-height: 20px;
  margin: none;
  padding: $padding;

  & > * {
    vertical-align: middle;
  }

  &.disabled {
    background: _palette(bg-primary);
  }

  input {
    font-size: $alp-font-size;
    width: 100%;
  }

  // Remove whole if placeholder too light
  input::placeholder {
    color: #bfbfbf;
  }

  .icon + input {
    width: calc(100% - #{$padding} - #{$icon-width + 20});
  }

  input,
  input:active,
  input:focus,
  input:disabled {
    background: none;
    border: none;
    outline: none;
  }

  .icon {
    display: inline-block;
    height: 22px;
    margin-right: $padding;
    margin-top: 1px;
    width: $icon-width;
  }

  .button {
    display: inline-block;
  }

  &.outlined {
    border: solid 1px _palette(input-border-outlined);
  }
}
